import { use, changeLanguage, InitOptions, TOptions } from 'i18next';
import React from 'react';
import { Trans, initReactI18next } from 'react-i18next';

import { ITranslateProps, Languages } from './Translate.domain';

export const initI18n = (options: InitOptions) => use(initReactI18next).init(options);

export const setLanguage = (lng: Languages): void => {
  changeLanguage(lng);
};

const components = {
  italic: <i />,
  bold: <strong />,
  space: <span>&nbsp;</span>,
};

export const Translate = ({ tOptions, ...restProps }: ITranslateProps) => {
  return (
    <span style={{ whiteSpace: 'pre-wrap' }}>
      <Trans components={components} tOptions={tOptions as TOptions} {...restProps} />
    </span>
  );
};
